(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 4813:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(31);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ SongStarterButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5992);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2048);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6432);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var Button = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "widthButton" && prop !== "heightButton" && prop !== "fontSizeButton" && prop !== "gradient" && prop !== "variant" && prop !== "colorButton";
    }
})(function(param) {
    var gradient = param.gradient, widthButton = param.widthButton, heightButton = param.heightButton, fontSizeButton = param.fontSizeButton, colorButton = param.colorButton, variant = param.variant, theme = param.theme;
    return _objectSpread({
        height: heightButton,
        width: widthButton,
        fontSize: fontSizeButton,
        fontFamily: "'Biennale', sans-serif",
        fontWeight: 700,
        borderRadius: "10px",
        padding: 0,
        textTransform: "none",
        color: colorButton || theme.palette.common.white
    }, variant === "outlined" && {
        border: "2px solid ".concat(theme.palette.common.white)
    }, {
        background: "rgb(0,0,0,0)"
    }, variant === "contained" && {
        backgroundImage: gradient || "linear-gradient(90deg, rgba(252,92,102,1) 0%, rgba(247,133,85,1) 100%)"
    }, {
        opacity: 1,
        transition: "opacity 0.3s cubic-bezier(0, 0, 0, 1) 0s",
        ":hover": {
            opacity: 0.85
        }
    });
});
var SongStarterButton = function(_param) {
    var onClick = _param.onClick, children = _param.children, _size = _param.size, size = _size === void 0 ? "medium" : _size, _variant = _param.variant, variant = _variant === void 0 ? "contained" : _variant, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _white = _param.white, white = _white === void 0 ? false : _white, gradientOverwrite = _param.gradient, type = _param.type, props = _objectWithoutProperties(_param, [
        "onClick",
        "children",
        "size",
        "variant",
        "fullWidth",
        "white",
        "gradient",
        "type"
    ]);
    var downSM = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var widthButton, heightButton, fontSizeButton, gradient, color;
    switch(size){
        case "small":
            widthButton = fullWidth ? "100%" : downSM ? 110 : 120;
            heightButton = downSM ? 32 : 36;
            fontSizeButton = downSM ? 13 : 14;
            break;
        case "medium":
            widthButton = fullWidth ? "100%" : downSM ? 230 : 240;
            heightButton = downSM ? 40 : 46;
            fontSizeButton = downSM ? 15 : 16;
            break;
        case "large":
            widthButton = fullWidth ? "100%" : downSM ? 180 : 200;
            heightButton = downSM ? 44 : 50;
            fontSizeButton = downSM ? 16 : 18;
            break;
    }
    if (white) {
        gradient = "linear-gradient(70deg, rgba(242,242,242,1) 0%, rgba(206,206,206,1) 100%)";
        color = variant === "outlined" ? "#fff" : "rgb(0,0,0)";
    }
    if (props.disabled) {
        gradient = "linear-gradient(70deg, rgba(242,242,242,0.2) 0%, rgba(206,206,206,0.2) 100%)";
        color = "rgb(48,48,48)";
    }
    if (gradientOverwrite) {
        gradient = gradientOverwrite;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, _objectSpread({}, props, {
        onClick: onClick,
        variant: variant,
        color: "secondary",
        disableElevation: true,
        type: type,
        widthButton: widthButton,
        heightButton: heightButton,
        fontSizeButton: fontSizeButton,
        colorButton: color,
        gradient: gradient,
        children: children
    }));
};



/***/ }),

/***/ 6576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ TopSpacing; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5992);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var TopSpacing = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        width: "100%",
        height: 240
    }, _defineProperty(_obj, theme.breakpoints.down("xl"), {
        height: 200
    }), _defineProperty(_obj, theme.breakpoints.down("md"), {
        height: 160
    }), _defineProperty(_obj, theme.breakpoints.down("sm"), {
        height: 120
    }), _obj;
});


/***/ }),

/***/ 873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ firebaseObject; }
/* harmony export */ });
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5532);
/* harmony import */ var firebase_firestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8492);
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(782);
/* harmony import */ var configs_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(665);
/* harmony import */ var firebase_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7651);





var isEmulating = configs_config__WEBPACK_IMPORTED_MODULE_3__/* .config.firebaseEmulator */ .v.firebaseEmulator;
if (!(configs_config__WEBPACK_IMPORTED_MODULE_3__/* .config.firebaseConfig.projectId */ .v.firebaseConfig.projectId === "song-starter")) {
    console.info("==== INITIALIZED FIREBASE ".concat(isEmulating ? "EMULATOR" : "CLOUD", ": ").concat(configs_config__WEBPACK_IMPORTED_MODULE_3__/* .config.firebaseConfig.projectId */ .v.firebaseConfig.projectId, " ===="), configs_config__WEBPACK_IMPORTED_MODULE_3__/* .config */ .v);
}
var fb = (0,firebase_app__WEBPACK_IMPORTED_MODULE_0__/* .initializeApp */ .ZF)(configs_config__WEBPACK_IMPORTED_MODULE_3__/* .config.firebaseConfig */ .v.firebaseConfig);
var db = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .getFirestore */ .ad)();
var app = (0,firebase_app__WEBPACK_IMPORTED_MODULE_0__/* .getApp */ .Mq)();
var storage = (0,firebase_storage__WEBPACK_IMPORTED_MODULE_4__/* .getStorage */ .cF)();
// const auth = getAuth() // THIS LOADS LARGE auth/iframe.js WHICH INCREASES BUNDLE SIZE
// initializeAuth throws an error if it's called more than once for the same app; save the reference.
var auth = (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .initializeAuth */ .uJ)(app, {
    persistence: [
        firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .indexedDBLocalPersistence */ .AP,
        firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .browserLocalPersistence */ .a$
    ]
});
var EMULATORS_STARTED = "EMULATORS_STARTED";
function startEmulators() {
    if (!__webpack_require__.g[EMULATORS_STARTED]) {
        __webpack_require__.g[EMULATORS_STARTED] = true;
        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .connectFirestoreEmulator */ .at)(db, "localhost", 8080);
        (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .connectAuthEmulator */ .S$)(auth, "http://localhost:9099/");
        (0,firebase_storage__WEBPACK_IMPORTED_MODULE_4__/* .connectStorageEmulator */ .a1)(storage, "localhost", 9199);
    }
}
if (isEmulating) startEmulators();
var firebaseObject = {
    fb: fb,
    db: db,
    auth: auth,
    storage: storage
};


/***/ }),

/***/ 31:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(5992);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(8675);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(2197);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(7550);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(1075);
// EXTERNAL MODULE: ./components/SongStarterHeader.tsx + 5 modules
var SongStarterHeader = __webpack_require__(2847);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/Footer.tsx
var Footer = __webpack_require__(2620);
// EXTERNAL MODULE: ./components/TopSpacing.tsx
var TopSpacing = __webpack_require__(6576);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(3955);
// EXTERNAL MODULE: ../../node_modules/@mui/material/TextField/TextField.js + 50 modules
var TextField = __webpack_require__(2286);
// EXTERNAL MODULE: ../../node_modules/@hookform/error-message/dist/index.esm.js
var dist_index_esm = __webpack_require__(4442);
;// CONCATENATED MODULE: ./components/TextField.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function TextField_TextField(props) {
    var type = props.type, name = props.name, formObject = props.formObject, rules = props.rules, label = props.label, _fullWidth = props.fullWidth, fullWidth = _fullWidth === void 0 ? true : _fullWidth, _variant = props.variant, variant = _variant === void 0 ? "outlined" : _variant, _size = props.size, size = _size === void 0 ? "small" : _size, _autoComplete = props.autoComplete, autoComplete = _autoComplete === void 0 ? "off" : _autoComplete, className = props.className, _readOnly = props.readOnly, readOnly = _readOnly === void 0 ? false : _readOnly, error = props.error, onBlur = props.onBlur, onChange = props.onChange, helperText = props.helperText, restProps = _objectWithoutProperties(props, [
        "type",
        "name",
        "formObject",
        "rules",
        "label",
        "fullWidth",
        "variant",
        "size",
        "autoComplete",
        "className",
        "readOnly",
        "error",
        "onBlur",
        "onChange",
        "helperText"
    ]);
    var register = formObject.register, errors = formObject.formState.errors;
    var _ref = register(name, _objectSpread({}, rules, type === "number" && {
        valueAsNumber: true
    })), ref = _ref.ref, rest = _objectWithoutProperties(_ref, [
        "ref"
    ]);
    var hasError = Boolean(error || errors[name]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, _objectSpread({
        name: rest.name,
        inputRef: ref,
        onBlur: function(e) {
            onBlur && onBlur(e);
            rest.onBlur(e);
        },
        onChange: function(e) {
            onChange && onChange(e);
            rest.onChange(e);
        },
        className: className,
        label: label,
        fullWidth: fullWidth,
        variant: variant,
        size: size,
        required: !!(rules === null || rules === void 0 ? void 0 : rules.required),
        autoComplete: autoComplete,
        error: hasError,
        helperText: hasError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ErrorMessage */.B, {
            name: name,
            errors: errors
        }) : helperText,
        type: type,
        InputProps: {
            readOnly: readOnly
        }
    }, restProps));
}

// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(2616);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Checkbox/Checkbox.js + 6 modules
var Checkbox = __webpack_require__(4540);
// EXTERNAL MODULE: ../../node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(982);
;// CONCATENATED MODULE: ./components/Checkbox.tsx





var Checkbox_Checkbox = function(param1) {
    var label = param1.label, name = param1.name, formObject = param1.formObject, rules = param1.rules, classNameCheckbox = param1.classNameCheckbox, _size = param1.size, size = _size === void 0 ? "medium" : _size, classNameLabel = param1.classNameLabel, _disabled = param1.disabled, disabled = _disabled === void 0 ? false : _disabled, color = param1.color, _defaultValue = param1.defaultValue, defaultValue = _defaultValue === void 0 ? false : _defaultValue, onChange = param1.onChange;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                label: (rules === null || rules === void 0 ? void 0 : rules.required) ? "".concat(label, " *") : label,
                disabled: disabled,
                className: classNameLabel,
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    name: name,
                    control: formObject.control,
                    defaultValue: defaultValue,
                    rules: rules,
                    render: function(param) {
                        var _field = param.field, onChangeRHF = _field.onChange, value = _field.value;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            name: name,
                            color: color || "primary",
                            onChange: function(e) {
                                onChangeRHF(e.target.checked);
                                onChange && onChange(e.target.checked);
                            },
                            checked: value,
                            className: classNameCheckbox,
                            size: size,
                            disabled: disabled
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ErrorMessage */.B, {
                    name: name,
                    errors: formObject.formState.errors
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/IconText.tsx



var GridStyled = (0,styled/* default */.ZP)(Grid/* default */.ZP)(function() {
    return {
        maxWidth: "calc(100% - 24px)",
        marginLeft: 8
    };
});
var IconText = function(param) {
    var label = param.label, value = param.value, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        alignItems: label ? "flex-end" : "center",
        spacing: 1,
        wrap: "nowrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridStyled, {
                item: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        color: "textSecondary",
                        noWrap: true,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        gutterBottom: true,
                        noWrap: true,
                        children: value
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(2078);
// EXTERNAL MODULE: ./components/IconButton.tsx
var IconButton = __webpack_require__(2594);
;// CONCATENATED MODULE: ./components/IconLink.tsx
function IconLink_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IconLink_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            IconLink_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var IconLink = function(param) {
    var href = param.href, onClick = param.onClick, label = param.label, icon = param.icon, newTab = param.newTab, color = param.color, style = param.style, tooltip = param.tooltip;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        alignItems: "center",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, IconLink_objectSpread({}, href !== undefined && {
                    onClick: function(e) {
                        e.stopPropagation();
                        window.open(href, newTab ? "_blank" : "_self");
                    }
                }, {
                    label: tooltip,
                    style: style,
                    size: "large",
                    children: icon
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, IconLink_objectSpread({
                    color: color,
                    underline: "hover",
                    variant: "body1",
                    href: href
                }, newTab && {
                    target: "_blank"
                }, href !== undefined && {
                    onClick: onClick
                }, {
                    children: label
                }))
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/Place.js
var Place = __webpack_require__(625);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/Email.js
var Email = __webpack_require__(5959);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/AccountBalance.js
var AccountBalance = __webpack_require__(9057);
// EXTERNAL MODULE: ./components/SongStarterButton.tsx
var SongStarterButton = __webpack_require__(2262);
// EXTERNAL MODULE: ./containers/GoogleTracking/utils.ts
var utils = __webpack_require__(9062);
// EXTERNAL MODULE: ./configs/config.ts
var config = __webpack_require__(665);
// EXTERNAL MODULE: ./containers/firebaseObject.tsx
var firebaseObject = __webpack_require__(873);
// EXTERNAL MODULE: ./hooks/useStore.tsx
var useStore = __webpack_require__(6208);
;// CONCATENATED MODULE: ./hooks/useAuth.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useAuth_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useAuth_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useAuth_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var useAuth = function() {
    var ref = _slicedToArray((0,useStore/* useStore */.oR)(), 2), store = ref[0], setStore = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    (0,react.useEffect)(function() {
        setLoading(true);
        if (store.user) {
            setLoading(false);
            return;
        }
        var unsubscribe = firebaseObject/* firebaseObject.auth.onAuthStateChanged */.N.auth.onAuthStateChanged(function(user) {
            if (user) {
                setStore(useAuth_objectSpread({}, store, {
                    user: user
                }));
            }
            setLoading(false);
        });
        return function() {
            return unsubscribe();
        };
    }, [
        store,
        setStore
    ]);
    return {
        user: store.user,
        auth: firebaseObject/* firebaseObject.auth */.N.auth,
        loading: loading
    };
};

;// CONCATENATED MODULE: ./hooks/useFunctionRequest.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var functionRequest = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var functionName, body, type, idToken, headers;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    functionName = param.functionName, body = param.body, type = param.type, idToken = param.idToken;
                    headers = {
                        "Content-Type": "application/json"
                    };
                    if (idToken) headers["id-token"] = idToken;
                    return _ctx.abrupt("return", fetch("".concat(config/* config.backendURL */.v.backendURL).concat(type || "functions", "/").concat(functionName), {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    }).then(function(response) {
                        if (response.ok) {
                            return response.json();
                        } else {
                            if (response.status === 404) {
                                throw response.statusText;
                            } else {
                                return response.json().then(function(error) {
                                    throw error;
                                });
                            }
                        }
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function functionRequest(_) {
        return _ref.apply(this, arguments);
    };
}();
var useFunctionRequest = function() {
    var user = useAuth().user;
    var makeRequest = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
            var functionName, body, type, idTokenOverwrite, idToken;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        functionName = param.functionName, body = param.body, type = param.type, idTokenOverwrite = param.idTokenOverwrite;
                        _ctx.t0 = idTokenOverwrite;
                        if (_ctx.t0) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 5;
                        return user === null || user === void 0 ? void 0 : user.getIdToken();
                    case 5:
                        _ctx.t0 = _ctx.sent;
                    case 6:
                        idToken = _ctx.t0;
                        _ctx.next = 9;
                        return functionRequest({
                            functionName: functionName,
                            body: body,
                            type: type,
                            idToken: idToken
                        });
                    case 9:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function makeRequest(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return makeRequest;
};
var backendRequest = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var functionName, body, type, ref, headers;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    functionName = param.functionName, body = param.body, type = param.type;
                    ;
                    headers = {
                        "Content-Type": "application/json"
                    };
                    _ctx.next = 5;
                    return (ref = firebaseObject/* firebaseObject.auth.currentUser */.N.auth.currentUser) === null || ref === void 0 ? void 0 : ref.getIdToken();
                case 5:
                    headers["id-token"] = _ctx.sent;
                    return _ctx.abrupt("return", fetch("".concat(config/* config.backendURL */.v.backendURL).concat(type || "functions", "/").concat(functionName), {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    }).then(function(response) {
                        if (response.ok) {
                            return response.json();
                        } else {
                            if (response.status === 404) {
                                throw response.statusText;
                            } else {
                                return response.json().then(function(error) {
                                    throw error;
                                });
                            }
                        }
                    }));
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function backendRequest(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ../../node_modules/firebase/firestore/dist/index.esm.js
var firestore_dist_index_esm = __webpack_require__(8492);
// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/esm/index.client.js + 83 modules
var index_client = __webpack_require__(7548);
// EXTERNAL MODULE: ../../node_modules/@sentry/minimal/esm/index.js + 1 modules
var esm = __webpack_require__(5876);
;// CONCATENATED MODULE: ./utils/errorLogger.tsx




var errorLogger = function(error) {
    var errorObject = {
        error: error ? JSON.stringify(error) : "NO ERROR FOUND FIVANO",
        errorDate: new Date()
    };
    if (config/* config.environment */.v.environment === "production") index_client === null || index_client === void 0 ? void 0 : esm/* captureException */.Tb(error);
    if (window === null || window === void 0 ? void 0 : window.location) errorObject.location = JSON.stringify(window.location);
    if (config/* config.environment */.v.environment === "development") console.error(error, errorObject);
    (0,firestore_dist_index_esm/* addDoc */.ET)((0,firestore_dist_index_esm/* collection */.hJ)(firebaseObject/* firebaseObject.db */.N.db, "errorLogger"), errorObject);
};

// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/useTranslation.js + 7 modules
var useTranslation = __webpack_require__(9179);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Alert/Alert.js + 6 modules
var Alert_Alert = __webpack_require__(2146);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Snackbar/Snackbar.js + 4 modules
var Snackbar = __webpack_require__(8443);
;// CONCATENATED MODULE: ./components/SnackbarSingle.tsx
function SnackbarSingle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SnackbarSingle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SnackbarSingle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var Alert = /*#__PURE__*/ react.forwardRef(function Alert(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, SnackbarSingle_objectSpread({
        elevation: 6,
        ref: ref,
        variant: "filled"
    }, props));
});
var SnackbarSingle = function(param) {
    var _severity = param.severity, severity = _severity === void 0 ? "success" : _severity, open = param.open, _authHideDuration = param.authHideDuration, authHideDuration = _authHideDuration === void 0 ? 5000 : _authHideDuration, onClose = param.onClose, message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
        open: open,
        autoHideDuration: authHideDuration,
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
            onClose: onClose,
            severity: severity,
            children: message
        })
    });
};

;// CONCATENATED MODULE: ./components/useSnackbar.tsx
function useSnackbar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useSnackbar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useSnackbar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var useSnackbar = function() {
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)({
        message: "Loading"
    }), snackbarProps = ref1[0], setSnackbarProps = ref1[1];
    return {
        openSnack: function(data) {
            setSnackbarProps(data);
            setOpen(true);
        },
        Snackbar: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SnackbarSingle, useSnackbar_objectSpread({}, snackbarProps, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                }
            }));
        }
    };
};

;// CONCATENATED MODULE: ./pages/contact.tsx
function contact_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function contact_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                contact_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                contact_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




















var IconTextWrapper = (0,styled/* default */.ZP)("div")(function() {
    return {
        marginLeft: 12,
        svg: {
            marginRight: 2
        },
        p: {
            whiteSpace: "unset"
        }
    };
});
var Contact = function() {
    var t = (0,useTranslation/* useTranslation */.$)("contact").t;
    var ref = (0,useTranslation/* useTranslation */.$)("common"), tcommon = ref.t;
    var ref1 = (0,react.useState)(""), statusMessage = ref1[0], setStatusMessage = ref1[1];
    var makeRequest = useFunctionRequest();
    var ref2 = useSnackbar(), openSnack = ref2.openSnack, Snackbar = ref2.Snackbar;
    var pageTitle = t("title_text");
    var formObject = (0,index_esm/* useForm */.cI)();
    var handleSubmit = formObject.handleSubmit, formState = formObject.formState;
    var submit = function() {
        var _ref = contact_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var body;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = data;
                        body.message = data.message + "\n    \n    MESSAGE FROM: ".concat(data.emailAddress);
                        (0,utils/* dataLayerPush */.lQ)("contact_form", {
                            emailData: data
                        });
                        _ctx.next = 5;
                        return makeRequest({
                            functionName: "contactEmail",
                            type: "public",
                            body: data
                        }).then(function() {
                            formObject.reset();
                            openSnack({
                                message: t("status_message")
                            });
                            setStatusMessage(t("status_message"));
                        }).catch(function(error) {
                            openSnack({
                                message: (error === null || error === void 0 ? void 0 : error.message) || "Error sending email, please try again or email to info@songstarter.com"
                            });
                            errorLogger(error);
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmit = handleSubmit(submit);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: pageTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SongStarterHeader/* SongStarterHeader */.L$, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h2",
                        component: "h1",
                        gutterBottom: true,
                        color: "textPrimary",
                        marginTop: "160px",
                        children: pageTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        maxWidth: "750px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            component: "p",
                            color: "textSecondary",
                            gutterBottom: true,
                            children: t("subtitle_text")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        spacing: 8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                md: 6,
                                children: statusMessage === "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                    onSubmit: onSubmit,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        container: true,
                                        spacing: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h5",
                                                        gutterBottom: true,
                                                        children: t("help_question")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        gutterBottom: true,
                                                        color: "textSecondary",
                                                        children: t("response_time_text")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField, {
                                                    label: "Name",
                                                    name: "name",
                                                    formObject: formObject,
                                                    rules: {
                                                        required: {
                                                            value: true,
                                                            message: tcommon("required_field")
                                                        }
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField, {
                                                    label: "Email",
                                                    name: "emailAddress",
                                                    formObject: formObject,
                                                    rules: {
                                                        required: {
                                                            value: true,
                                                            message: tcommon("required_field")
                                                        },
                                                        pattern: {
                                                            value: /\S+@\S+\.\S+/,
                                                            message: t("contact_email_rules_message")
                                                        }
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField, {
                                                        label: "Message",
                                                        name: "message",
                                                        formObject: formObject,
                                                        rules: {
                                                            required: {
                                                                value: true,
                                                                message: tcommon("required_field")
                                                            },
                                                            minLength: {
                                                                value: 50,
                                                                message: t("message_length_message")
                                                            }
                                                        },
                                                        fullWidth: true,
                                                        rows: 8,
                                                        multiline: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox, {
                                                        rules: {
                                                            required: true
                                                        },
                                                        name: "privacy",
                                                        formObject: formObject,
                                                        label: "I accept the privacy policy"
                                                    }),
                                                    !!formState.errors.privacy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        color: "error",
                                                        children: t("terms_and_conditions")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        color: "error"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SongStarterButton/* SongStarterButton */.a, {
                                                        variant: "contained",
                                                        size: "medium",
                                                        onClick: onSubmit,
                                                        children: t("send_email_button")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    py: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: "textSecondary",
                                        gutterBottom: true,
                                        children: statusMessage
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h5",
                                                gutterBottom: true,
                                                sx: {
                                                    marginLeft: "14px"
                                                },
                                                children: t("company_information")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTextWrapper, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconText, {
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Place/* default */.Z, {}),
                                                    value: "Retentieweg 24, 7572 PH, Oldenzaal, The Netherlands"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLink, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Email/* default */.Z, {
                                                    style: {
                                                        marginLeft: -1
                                                    }
                                                }),
                                                label: "info@songstarter.com",
                                                tooltip: t("open_mail_link"),
                                                href: "mailto:info@songstarter.com"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTextWrapper, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconText, {
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountBalance/* default */.Z, {}),
                                                    value: "VAT: NL861389803B01"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopSpacing/* TopSpacing */.O, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var contact = (Contact);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [192,467,90,409,295,438,164,774,888,179], function() { return __webpack_exec__(4813); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);